import React from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import ErrorBoundary from 'components/errorBoundary'
import { Typography, Avatar } from 'components'
import getImageUrl from 'utils/getImageUrl'
import { useWindowSize } from 'react-use'

const Container = styled.div`
  width: 100%;
  // margin-bottom: 35px;

  // @media (max-width: 425px) {
  //   margin-bottom: 20px;
  // }
`
const CustomRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;

  ${({ clickable, theme }) => {
    if (clickable) {
      return css`
        :hover {
          cursor: pointer;
          p {
            text-decoration: underline;
            color: ${theme['sa-blue']};
          }
        }
      `
    }
  }}
`
const InstructorName = styled((props) => <Typography {...props} />)`
  font-size: 14px;
  color: #253e87;

  @media (max-width: 425px) {
    font-size: 12px;
  }
`

const InstructorRow = ({ clickable, teacher, textHedingProps }) => {
  const { width } = useWindowSize()
  const avatarSize = width <= 425 ? 48 : 58
  const imageSize = avatarSize * 2

  return (
    <CustomRow clickable={clickable}>
      <Avatar
        noneBorder
        size={avatarSize}
        src={getImageUrl(
          teacher?.profileImage,
          `https://via.placeholder.com/${imageSize}`,
          imageSize,
          imageSize
        )}
      />
      <InstructorName numberOfLines={2}>
        <Typography
          color="primary1"
          id="course.detail.textHeding"
          fontSize="text-sm"
          fontWeight={600}
        >
          {textHedingProps}
        </Typography>
        <Typography>
          {teacher?.name ? teacher.name : `${teacher?.firstname} ${teacher?.lastname}`}
        </Typography>
      </InstructorName>
    </CustomRow>
  )
}

const Instructor = (props) => {
  const { course, textHeding } = props
  const { customTeacherList = [], teachers = [] } = course
  const teacher = customTeacherList.length > 0 ? customTeacherList[0] : teachers[0]
  const academy = {
    description: '',
    name: course?.school?.name,
    profileImage: course?.school?.logo,
  }
  const clickable = Boolean(teacher?.slug)
  const link = `/users/${teacher?.slug}`
  if (!teacher) {
    return null
  }
  return (
    <ErrorBoundary>
      <Container>
        {clickable ? (
          <Link to={link} target="_blank" rel="noopener noreferrer">
            <InstructorRow
              teacher={textHeding === 'Instructor' ? teacher : academy}
              clickable={clickable}
              textHedingProps={textHeding}
            />
          </Link>
        ) : (
          <InstructorRow
            teacher={textHeding === 'Instructor' ? teacher : academy}
            clickable={clickable}
            textHedingProps={textHeding}
          />
        )}
      </Container>
    </ErrorBoundary>
  )
}

export default Instructor
